var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummaryAppt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0359 3.33333H7.36926C5.96913 3.33333 5.26907 3.33333 4.73429 3.60582C4.26388 3.8455 3.88143 4.22795 3.64175 4.69836C3.36926 5.23314 3.36926 5.9332 3.36926 7.33333V13.5C3.36926 14.9001 3.36926 15.6002 3.64175 16.135C3.88143 16.6054 4.26388 16.9878 4.73429 17.2275C5.26907 17.5 5.96913 17.5 7.36926 17.5H13.5359C14.9361 17.5 15.6361 17.5 16.1709 17.2275C16.6413 16.9878 17.0238 16.6054 17.2634 16.135C17.5359 15.6002 17.5359 14.9001 17.5359 13.5V10.8333M11.7026 14.1667H6.7026M13.3693 10.8333H6.7026M17.637 3.23223C18.6133 4.20854 18.6133 5.79146 17.637 6.76777C16.6607 7.74408 15.0778 7.74408 14.1015 6.76777C13.1252 5.79146 13.1252 4.20854 14.1015 3.23223C15.0778 2.25592 16.6607 2.25592 17.637 3.23223Z",
    stroke: "#0054B6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryAppt);
export default __webpack_public_path__ + "static/media/SummaryAppt.44681ce012e72cb7db21cb86c078d373.svg";
export { ForwardRef as ReactComponent };